export default __webpack_public_path__ + "static/media/twitter.193a169d.svg";